import { States } from '../../../../../../constants';

export const validStateOptions: string[] = [];
States.forEach((state) => {
  validStateOptions.push(state.name);
});

export const dealTypeOptions = [
  'Affordable Rental Housing: 4%, 9%',
  'Home Ownership',
  'Market Rate Multifamily',
  'Mixed Use',
  'Existing Operating Property',
  'Other',
];

export const constructionTypeOptions = ['New Construction', 'Historic Renovation', 'Renovation', 'Adaptive Reuse', 'In-Place Renovation'];

export const acquisitionTypeOptions = ['Off-Market', 'On-Market', 'Joint venture with land owner', 'Other'];

export const siteControlStatusOptions = [
  'LOI Obtained',
  'Purchase Contract Executed',
  'RFP Submitted',
  'Exclusive Negotiating Period Entered Into',
  'Other',
];

export const projectByRightOptions = ['Yes', 'No', 'Not Yet Determined'];
